import { cn } from '@reflex/ui/lib/utils';

/** Shared mobile sheet + desktop dialog sizing for persona create/edit surfaces. */
export const PERSONA_FORM_DIALOG_CONTENT_CLASS = cn(
  'flex max-h-[90vh] flex-col gap-0 overflow-hidden p-0 sm:max-w-2xl',
  'max-sm:top-0 max-sm:h-app max-sm:max-h-app max-sm:max-w-full max-sm:translate-y-0 max-sm:rounded-none max-sm:border-0',
  'max-sm:data-[state=open]:zoom-in-100 max-sm:data-[state=open]:slide-in-from-bottom max-sm:data-[state=closed]:zoom-out-100 max-sm:data-[state=closed]:slide-out-to-bottom',
);

export const PERSONA_FORM_DIALOG_HEADER_CLASS =
  'shrink-0 flex-col items-stretch gap-1.5 space-y-0 px-4 pt-4 pb-2 text-left';

export const PERSONA_FORM_DIALOG_FOOTER_CLASS =
  'flex w-full shrink-0 items-center justify-end gap-2 border-t border-border bg-muted/30 px-4 py-3 max-sm:pb-[calc(env(safe-area-inset-bottom)+0.75rem)]';
